import { create } from 'zustand';

interface CarrierExclusionsState {
  hiddenCarriers: string[];
  actions: {
    toggleCarrier: (carrierName: string) => void;
    setHiddenCarriers: (carriers: string[]) => void;
    resetCarriers: () => void;
  };
}

export const useCarrierExclusionsStore = create<CarrierExclusionsState>(set => ({
  hiddenCarriers: [],
  actions: {
    toggleCarrier: carrierName =>
      set(state => {
        const isHidden = state.hiddenCarriers.includes(carrierName);
        return {
          hiddenCarriers: isHidden
            ? state.hiddenCarriers.filter(c => c !== carrierName)
            : [...state.hiddenCarriers, carrierName],
        };
      }),
    setHiddenCarriers: carriers => set({ hiddenCarriers: carriers }),
    resetCarriers: () => set({ hiddenCarriers: [] }),
  },
}));

export const useHiddenCarriers = () =>
  useCarrierExclusionsStore(state => state.hiddenCarriers);

export const useCarrierExclusionsActions = () =>
  useCarrierExclusionsStore(state => state.actions);
